import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  width: 690px;
  max-width: 100%;
  margin-top: 72px;
  padding: ${Spacing.S24} ${Spacing.S24} ${Spacing.S24} ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};
`

export const IconSquircle = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.Purple100};
`

export const CardContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${Spacing.S4};
`
